import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('users/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('users/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('users/all', val_params);
  }

  get(val_id: number) {
    return this.restService.get('users/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('users/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('users/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('users/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('users/delete', val_id);
  }

  listProfilesUser(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('users/list_profile', val_params);
  }

  activedUser(val_id: number, data: any) {
    return this.restService.update('users/activated', val_id, data);
  }
}
